<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title">
          <h1>대시보드</h1>
        </div>
        <article>
          <div class="row4 dashboard">
            <section class="section1 totalBox">
              <div class="item">
                <span class="iconBox bgOrange">
                  <img
                    src="../../assets/images/admin/dashboard/Paper.png"
                    alt="paper"
                  />
                </span>
                <div class="totalTxt">
                  <p>미완료 설문</p>
                  <h5>
                    {{ notCompleteSurvay }}
                  </h5>
                </div>
              </div>
              <div class="item">
                <span class="iconBox bgPurple">
                  <img
                    src="../../assets/images/admin/dashboard/Swap.png"
                    alt="Swap"
                  />
                </span>
                <div class="totalTxt">
                  <p>제품·서비스 승인 요청</p>
                  <h5>
                    {{ approval }}
                  </h5>
                </div>
              </div>
              <div class="item">
                <span class="iconBox bgDarkblue">
                  <img
                    src="../../assets/images/admin/dashboard/ProfileBlue.png"
                    alt="ProfileBlue"
                  />
                </span>
                <div class="totalTxt">
                  <p>신규회원</p>
                  <h5>
                    {{ newUser }}
                  </h5>
                </div>
              </div>
              <div class="item">
                <span class="iconBox bgRed">
                  <img
                    src="../../assets/images/admin/dashboard/Profile.png"
                    alt="Profile"
                  />
                </span>
                <div class="totalTxt">
                  <p>탈퇴회원</p>
                  <h5>
                    {{ withdrawalUser }}
                  </h5>
                </div>
              </div>
            </section>

            <section class="section2">
              <div class="inner flex">
                <div class="left">
                  <!-- 접속자 수 구하는 건 없음 (기능 제외)
                                    <div class="viewCountBox">
                                        <div class="head flex">
                                            <div class="title">
                                                <h3>접속자 수</h3>
                                            </div>
                                            <div class="viewCountTotalBox">
                                                <div class="total">
                                                    <span>전체</span>
                                                    <span class="data">3,123,213</span>
                                                    <span>명</span>
                                                </div>
                                                <div class="withdraw">
                                                    <span>탈퇴</span>
                                                    <span class="data">0</span>
                                                    <span>명</span>
                                                </div>
                                                <div class="today">
                                                    <span>오늘</span>
                                                    <span class="data">2,034</span>
                                                    <span>명</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="graphBody">

                                        </div>
                                    </div>
                                    -->
                  <div class="recentlySurveyBox">
                    <div class="head flex">
                      <div class="title">
                        <h3>최근 설문</h3>
                      </div>
                      <div class="viewCountTotalBox">
                        <div class="total">
                          <span>개인회원</span>
                        </div>
                        <div class="withdraw">
                          <span>기업회원</span>
                        </div>
                        <div class="refreshBtnbox">
                          <span> {{ currentDate }} 기준 </span>
                          <button
                            @click="getDashboardData()"
                            style="cursor: pointer"
                          ></button>
                        </div>
                      </div>
                    </div>
                    <div class="graphBody">
                      <div
                        v-for="(item, index) in surveyList"
                        :key="index"
                        @click="detailView(item.IDX)"
                        class="item"
                        style="display: flex;"
                      >
                        <div style="width: 80%">
                          <p style="margin-bottom: 15px; font-weight: bold;">
                            {{ item.TITLE }}
                          </p>

                          <b-progress
                            :max="100"
                            class="userProgress"
                            v-if="
                              item.TARGET === 'ALL' || item.TARGET === 'USER'
                            "
                          >
                            <!--:label="`${((value11 / max11) * 100).toFixed(2)}%`" -->
                            <b-progress-bar
                              :value="item.USER_NUM"
                              :label="
                                `${((item.USER_NUM / 100) * 100).toFixed(1)}%`
                              "
                            ></b-progress-bar>
                          </b-progress>
                          <br
                            v-if="
                              item.TARGET === 'ALL' || item.TARGET === 'USER'
                            "
                          />
                          <b-progress
                            :max="100"
                            class="corpProgress"
                            v-if="
                              item.TARGET === 'ALL' || item.TARGET === 'CORP'
                            "
                          >
                            <!--:label="`${((value11 / max11) * 100).toFixed(2)}%`" -->
                            <b-progress-bar
                              :value="item.CORP_NUM"
                              :label="
                                `${((item.CORP_NUM / 100) * 100).toFixed(1)}%`
                              "
                            ></b-progress-bar>
                          </b-progress>
                          <br />
                        </div>
                        <div style="width: 20%; text-align: center;">
                          <p style="font-size: 16px; color: #aaa;">참여자 수</p>
                          <div
                            style="margin-top: 45px;"
                            v-if="
                              item.TARGET === 'ALL' || item.TARGET === 'USER'
                            "
                          >
                            총 {{ item.CMPL_USER_NUM }} /
                            {{ item.TOTAL_USER_NUM }} (명)
                          </div>
                          <div
                            style="margin-top: 22px;"
                            v-if="item.TARGET === 'CORP'"
                          >
                            총 {{ item.CMPL_USER_NUM }} /
                            {{ item.TOTAL_USER_NUM }} (명)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="head flex">
                    <div class="title">
                      <h3>1:1 문의</h3>
                    </div>
                    <div class="viewDetailBtnBox">
                      <router-link to="/QnA">더보기</router-link>
                    </div>
                  </div>
                  <div class="simpleQNAViewBox">
                    <div
                      v-for="(item, index) in qnaList"
                      :key="index"
                      class="item"
                    >
                      <div class="top">
                        <div class="left">
                          <img :src="item.MAIN_FILE" alt="" />
                        </div>
                        <div class="right">
                          <span>
                            {{ item.REGDATE }}
                          </span>
                        </div>
                      </div>
                      <div class="bot">
                        <div class="left">
                          <span class="qnaName">
                            {{ item.NAME }}
                          </span>
                          <p>
                            {{ item.TITLE }}
                          </p>
                        </div>
                        <div class="right">
                          <div class="viewDetailBtnBox">
                            <router-link
                              :to="'/qNADetail/' + item.IDX"
                            ></router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="section3">
              <div class="inner flex">
                <div class="productTableBody">
                  <div class="head flex">
                    <div class="title">
                      <h3>제품</h3>
                    </div>
                    <div class="viewDetailBtnBox">
                      <router-link to="/admin/productManagement"
                        >더보기</router-link
                      >
                    </div>
                  </div>
                  <div class="tableContainer">
                    <div class="sampleTemplate">
                      <b-table
                        id="table"
                        :fields="fields"
                        :items="getProduct"
                        :per-page="perPage"
                        :current-page="currentPage"
                        @row-clicked="onRowClickedProduct"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        ref="table"
                        selectable
                        hover
                        show-empty
                        empty-text="제품이 존재하지 않습니다."
                      >
                        <template #emptyfiltered="scope">
                          <h4>{{ scope.emptyFilteredText }}</h4>
                        </template>

                        <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                          </template>
                          <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                          </template>
                        </template>
                      </b-table>
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalCnt"
                        :per-page="perPage"
                        aria-controls="table"
                      >
                      </b-pagination>
                    </div>
                  </div>
                </div>
                <div class="serviceTableBody">
                  <div class="head flex">
                    <div class="title">
                      <h3>서비스</h3>
                    </div>
                    <div class="viewDetailBtnBox">
                      <router-link to="/admin/serviceManagement"
                        >더보기</router-link
                      >
                    </div>
                  </div>
                  <div class="tableContainer">
                    <div class="sampleTemplate">
                      <b-table
                        id="table"
                        :fields="fields"
                        :items="getService"
                        :per-page="perPage_service"
                        :current-page="currentPage_service"
                        @row-clicked="onRowClickedService"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        ref="table"
                        selectable
                        hover
                        show-empty
                        empty-text="서비스가 존재하지 않습니다."
                      >
                        <template #emptyfiltered="scope">
                          <h4>{{ scope.emptyFilteredText }}</h4>
                        </template>

                        <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                          </template>
                          <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                          </template>
                        </template>
                      </b-table>
                      <b-pagination
                        v-model="currentPage_service"
                        :total-rows="totalCnt_service"
                        :per-page="perPage_service"
                        aria-controls="table"
                      >
                      </b-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "@/axios/axios";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      qnaList: [],
      surveyList: [],
      surveyTitle: [],
      progress_value: [],
      progress_label: [],
      currentDate: "",
      newUser: 0,
      notCompleteSurvay: 0,
      approval: 0,
      withdrawalUser: 0,
      totalNo: 1,
      perPage: 4,
      currentPage: 1,
      totalCnt: 0,
      perPage_service: 4,
      currentPage_service: 1,
      totalCnt_service: 0,
      //sortBy: 최초 보이는 화면의 sort 기준, sortDesc 순서
      sortBy: "IDX",
      sortDesc: false,
      fields: [
        {
          key: "ROWNUM",
          label: "No",
          sortable: false,
          sortDirection: "desc",
          class: "text-center",
        },
        {
          key: "STATUS_STR",
          label: "상태",
          sortable: false,
          isActive: true,
          class: "statusOn text-center",
        },
        {
          key: "COMPANY",
          label: "업체",
          sortable: false,
          class: "text-center",
        },
        {
          key: "NAME",
          label: "제품명",
          sortable: false,
          class: "text-center",
        },
      ],
    };
  },
  methods: {
    getProduct() {
      return axios
        .post("/api/admin/product/getProductList", {
          currentPage: this.currentPage,
          perPage: this.perPage,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          searchText: this.searchText,
          roleName: this.roleName,
        })
        .then((response) => {
          const items = response.data.items;
          this.totalCnt = response.data.totalCnt;
          return items;
        })
        .catch((error) => {
          console.log("error: " + error);
          return [];
        });
    },
    getService() {
      return axios
        .post("/api/admin/service/getServiceList", {
          currentPage: this.currentPage_service,
          perPage: this.perPage_service,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          searchText: this.searchText,
          roleName: this.roleName,
        })
        .then((response) => {
          const items = response.data.items;
          this.totalCnt_service = response.data.totalCnt;
          return items;
        })
        .catch((error) => {
          console.log("error: " + error);
          return [];
        });
    },
    getDashboardData() {
      return axios
        .post("/api/admin/dashboard/getDashboardData", {
          type: "test",
        })
        .then((response) => {
          //                    this.surveyList1 = [11,21];
          this.newUser = response.data.dashboard.NEW_USER;
          this.notCompleteSurvay = response.data.dashboard.NOT_COMPLETE_SURVEY;
          this.approval =
            response.data.dashboard.APPROVAL_PRODUCT +
            response.data.dashboard.APPROVAL_SERVICE;
          this.withdrawalUser = response.data.dashboard.WITHDRAWAL_USER;
          this.qnaList = response.data.qnaList;
          this.surveyList = response.data.surveyList;
          this.currentDate = response.data.currentDate;
        })
        .catch((error) => {
          console.log("error: " + error);
          return [];
        });
    },
    onRowClickedProduct(item) {
      this.$router.push({ path: "/admin/productDetail/" + item.IDX });
    },
    onRowClickedService(item) {
      this.$router.push({ path: "/admin/serviceDetail/" + item.IDX });
    },
  },
  mounted() {
    this.getDashboardData();
  },
};
</script>

<style scoped lang="scss">
.sampleTemplate ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}

.userProgress {
  background: #c8ccdd;
  border-radius: 15px;
}

.userProgress > div {
  background: #26336a;
  border-radius: 15px;
  color: #fff;
  padding: 1px 20px;
  font-size: 13px;
}

.corpProgress {
  background: #f7d1d1;
  border-radius: 15px;
}

.corpProgress > div {
  background: #9e1915;
  border-radius: 15px;
  color: #fff;
  padding: 1px 20px;
  font-size: 13px;
}
</style>
